import { Utils } from "../Utils/Utils";
import Control from "./Control";
export default class MultiSelectControl extends Control {
    constructor(field, isMain = true) {
        super(field);
        this.isMain = true;
        this.isMain = isMain;
        if (!Utils.isOk(this.field.placeHolder)) {
            this.field.placeHolder = " - Please Select - ";
        }
    }
    renderField() {
        let ret = [];
        ret.push(`<div ${this.isMain ? " data-main" : ""} id="${this.field.internalId}">`);
        // build the multi select and "Other" textbox controls with radio buttons for each control
        if (this.field.selectionFieldSettings.allowCustomValue) {
            ret.push(`<div class="row-two-controls">`);
            ret.push(`<input type="radio" name="${this.field.internalId}_radio_group" group-controls=${this.field.internalId} 
                    id="${this.field.internalId}_option_selection" value="0"
                    ${!(this.initialValue && this.initialValue.isCustomValue) ? " checked" : ""}>`);
            ret.push(...this.renderSelectWithOptions());
            ret.push("</div>");
            ret.push('<div class="row-two-controls">');
            ret.push(`<input type="radio" name="${this.field.internalId}_radio_group" group-controls=${this.field.internalId} 
                    id="${this.field.internalId}_custom_other_selection" value="1" ${this.initialValue && this.initialValue.isCustomValue ? " checked" : ""}>`);
            ret.push(`<input type="text" disabled id="${this.field.internalId}_custom_option_value" group-controls=${this.field.internalId}  
                    placeholder="Other" 
                    ${this.initialValue && this.initialValue.isCustomValue && this.initialValue.customValue ? " value='" + this.initialValue.customValue + "'" : ""}>`);
            ret.push("</div>");
        }
        else {
            ret.push(...this.renderSelectWithOptions());
        }
        ret.push("</div>");
        return ret.join("");
    }
    renderPreview() {
        var _a, _b, _c, _d;
        const initialValue = this.initialValue;
        if (!initialValue) {
            return "";
        }
        if (initialValue.isCustomValue) {
            return `<span>${initialValue.customValue}</span>`;
        }
        const selectedValues = (_c = (_b = (_a = this.field.selectionFieldSettings) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.filter((o) => initialValue === null || initialValue === void 0 ? void 0 : initialValue.valueIds.includes(o.optionId))) === null || _c === void 0 ? void 0 : _c.map(val => val.optionValue);
        return `<span>${(_d = selectedValues.join(", ")) !== null && _d !== void 0 ? _d : ""}</span>`;
    }
    getSelectionValues() {
        let radioValue = "0";
        if (this.field.selectionFieldSettings.allowCustomValue) {
            const radio = document.querySelectorAll(`#control_${this.field.internalId} input[type="radio"]:checked`);
            radioValue = radio[0].value;
        }
        let ret;
        if (radioValue === "1") {
            const otherField = (document.querySelector(`#control_${this.field.internalId} input[type="text"]`));
            ret = {
                isCustomValue: true,
                customValue: otherField === null || otherField === void 0 ? void 0 : otherField.value,
                valueIds: [],
                lovValueIds: [],
            };
        }
        else {
            const checkboxes = document.querySelectorAll(`#control_${this.field.internalId} .multiselect-control input[type="checkbox"]:checked`);
            const selectedValues = Array.from(checkboxes).map(cb => cb.value);
            ret = {
                isCustomValue: false,
                customValue: "",
                valueIds: selectedValues,
                lovValueIds: [],
            };
        }
        return ret;
    }
    getValue() {
        return JSON.stringify(this.getSelectionValues());
    }
    validate(clearValidationMessages = true, ghostMode = false) {
        const valid = super.validate(clearValidationMessages, ghostMode);
        if (!valid) {
            let value = this.getSelectionValues();
            if (value.isCustomValue) {
                this.field.validationMessages[0] +=
                    ' Please make sure that the "Other" field is not empty.';
            }
        }
        return valid;
    }
    getRawValue() {
        const values = this.getSelectionValues();
        return values.isCustomValue ? values.customValue : values.valueIds;
    }
    afterRender() {
        if (this.field.selectionFieldSettings.allowCustomValue) {
            const radios = document.querySelectorAll(`#control_${this.field.internalId} input[type="radio"]`);
            radios.forEach((radio) => radio.addEventListener("change", () => this.customValueChange()));
        }
        const checkboxes = document.querySelectorAll(`#select_${this.field.internalId} input[type="checkbox"]`);
        checkboxes.forEach(cb => {
            cb.addEventListener("change", () => this.onChange());
        });
        super.afterRender();
    }
    onChange(validate = true) {
        this.customValueChange();
        super.onChange(validate);
    }
    renderSelectWithOptions() {
        var _a, _b;
        let ret = [];
        ret.push(`<div class="multiselect-control" id="select_${this.field.internalId}">`);
        (_b = (_a = this.field.selectionFieldSettings) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.forEach((option) => {
            const isChecked = this.initialValue && this.initialValue.valueIds.includes(option.optionId);
            ret.push(`<div class="multiselect-control-item">
                    <input type="checkbox" id="${this.field.internalId}_${option.optionId}" value="${option.optionId}"${isChecked ? " checked" : ""} />
                    <label for="${this.field.internalId}_${option.optionId}">${option.optionValue}</label>
                </div>`);
        });
        ret.push(`</div>`);
        return ret;
    }
    customValueChange() {
        const radio = document.querySelector(`#control_${this.field.internalId} input[type="radio"]:checked`);
        if (radio) {
            const multiselect = document.querySelector(`#select_${this.field.internalId}`);
            const otherField = (document.querySelector(`#control_${this.field.internalId} input[type="text"]`));
            const radioValue = radio.value;
            if (radioValue === "1") {
                multiselect === null || multiselect === void 0 ? void 0 : multiselect.classList.add("disabled");
                otherField.disabled = false;
            }
            else {
                multiselect === null || multiselect === void 0 ? void 0 : multiselect.classList.remove("disabled");
                otherField.disabled = true;
            }
        }
    }
}
